import { render, staticRenderFns } from "./GroupRewards.vue?vue&type=template&id=ded63a34&"
import script from "./GroupRewards.vue?vue&type=script&lang=js&"
export * from "./GroupRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports